import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const departments = [
    { "name": "About the Diploma", "id": "about-diploma" },
    { "name": "Time Table", "id": "timetable" },
    { "name": "Achievements", "id": "achievements" },
    { "name": "Contact", "id": "contact" }
];

const contentData = {
    "about-diploma": (
        <>
            <p>Today, the entire world is realizing and accepting the scientific and spiritual effects of Vedic mantras. Therefore, the whole world is eager and ready to know the secrets of Vedic mantras. With this sentiment, the Veda Diploma Department of the university properly performs the Vedic remedies for achieving desired results, as enshrined in the Vedas, through Vedic and classical methods, so that the Vedic tradition can be preserved and established.</p>
            <p>The University's Veda Diploma is fully committed and resolved for the welfare of students and society, from which university students and the public will certainly benefit. The objectives analyzed in light of the above subjects are as follows:</p>
            <ol>
                <li>Establishing social harmony through the Vedas.</li>
                <li>Infusing positivity in society through Vedic rituals and observances.</li>
                <li>Achieving social purity through sacrifices and other practices mentioned in the Vedas.</li>
                <li>Building an organized society through physical well-being guided by Vedic vows.</li>
                <li>Building a proper personality through Vedic sanskars (rites of passage).</li>
                <li>Imparting ethical elements to students through knowledge of Vedic aphorisms.</li>
                <li>Transmitting positive energy through the chanting of mantras.</li>
                <li>Establishing authentic and classical knowledge related to the Vedas.</li>
                <li>Solving all problems through Vedic remedies.</li>
            </ol>
        </>
    ),
    "timetable": (
        <>
            <p>The time table will be presented at the commencement of the session.</p>
        </>
    ),
    "achievements": (
        <>
            <p>Being a new course, there are no current achievements. Any new achievements by the department after the commencement of the course will be presented in due course.</p>
        </>
    ),
    "contact": (
        <>
            <p>Dr. Akhilesh Kumar Mishra</p>
            <p>Coordinator - Veda Diploma</p>
            <p>Contact No. – 7631274367</p>
            <p>Email – akhimishra111@gmail.com</p>
        </>
    )
};

export default function VedaDiploma_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeId, setActiveId] = useState(departments[0].id);
    const [currentContent, setCurrentContent] = useState(contentData[departments[0].id]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) { // Bootstrap's md breakpoint
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setActiveId(deptId);
        setCurrentContent(contentData[deptId]);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <aside className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}>
                <h5 className="text-center fw-bold mb-3 text-dark">Veda Diploma</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            onClick={() => handleItemClick(dept.id)}
                            className={`mb-1 p-2 rounded shadow-sm small cursor-pointer ${activeId === dept.id
                                ? "bg-primary text-white"
                                : "bg-white text-dark"
                                }`}
                            style={{ cursor: "pointer" }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto">
                <h5>Main Content</h5>
                <div>{currentContent}</div>
            </main>
        </div>
    );
}